/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Col, Row } from 'react-bootstrap';
import InlineCKEditor from '../../../components/common/editor/inline-editor/index';
import PostcodePlanForm from '../../../components/submissions/postcode-plan/postcode-plan-form';
import { loadPageContent } from '../../../actions/content';
import {
  getPostcodePlanObjectiveMeta,
  createPostcodePlanObjectiveSubmission
} from '../../../actions/postcode-plan-objectives';
import { history } from '../../../store';

const model = 'deep.postcodePlanObjective';

class PostcodePlanFormPage extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'postcode-plan-objective';
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
    dispatch(getPostcodePlanObjectiveMeta());
  }

  handleContentSaved = () => {
    const { dispatch } = this.props;

    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  handleSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, createPostcodePlanObjectiveSubmission(payload, dispatch)))
      .then(() => {
        dispatch(actions.reset(model));
        history.push('/submissions#submit_postcode_plan_data');
      });
  }

  render() {
    const { isLoading, meta, contents } = this.props;

    return (
      <div className="container-fluid">
        {isLoading ?
          'Loading...' : (
            <div>
              <Row>
                <Col md={12}>
                  <InlineCKEditor
                    contents={contents['postcode-plan-objective_content_text']}
                    identifier={'postcode-plan-objective_content_text'}
                    onContentSaved={this.handleContentSaved}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="padding-flush">
                  <PostcodePlanForm
                    model={model}
                    meta={meta}
                    onSubmit={this.handleSubmit}
                  />
                </Col>
              </Row>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  postcodePlanObjective: state.postcodePlanObjectives.postcodePlanObjective,
  isLoading: !state.postcodePlanObjectives.fetched && state.postcodePlanObjectives.fetching,
  meta: state.postcodePlanObjectives.meta,
  contents: state.content.list
});

export default connect(mapStateToProps)(PostcodePlanFormPage);



// WEBPACK FOOTER //
// ./src/components/submissions/postcode-plan/postcode-plan-form-page.jsx